import {SearchTypes} from "../../types/common/search.types";
import apiClient from '../apiClient';
import {ResponseDto} from "../ResponseDto";
import {PageTypes} from "../../types/page.types";
import {PrepaidSettingTypes} from "../../types/transaction/prepaid.setting.types";
import {
    ChargeCancelRequestTypes,
    ChargeRequestLogTypes,
    ChargeRequestTypes,
    ChargeTypes
} from "../../types/transaction/transaction.types";

export const getMemberChargeList = (searchData : SearchTypes) =>
    apiClient.get<ResponseDto<PageTypes>>("/api/front/charge/getMemberChargeList",
        {
            params: searchData,
            headers: {'Content-Type': 'application/json'}
        }
    );


export const getMemberChargeSetting = () =>
    apiClient.get<ResponseDto<PrepaidSettingTypes>>("/api/front/charge/getChargeSetting");


export const getMemberChargeDetail = (transactionCode : string) =>
    apiClient.get<ResponseDto<ChargeTypes>>("/api/front/charge/getMemberChargeDetail",
        {
            params: {transactionCode},
            headers: {'Content-Type': 'application/json'}
        }
    );

export const saveChargeData = (chargeRequestTypes: ChargeRequestTypes) =>
    apiClient.post<ResponseDto<any>>("/api/front/charge/saveChargeData", chargeRequestTypes
    );


export const saveChargeCancelData = (chargeCancelRequestTypes: ChargeCancelRequestTypes) =>
    apiClient.post<ResponseDto<any>>("/api/front/charge/saveChargeCancelData", chargeCancelRequestTypes
    );

export const saveChargeRequestLog = (chargeRequestLogTypes: ChargeRequestLogTypes) =>
    apiClient.post<ResponseDto<any>>("/api/front/charge/saveChargeRequestLog", chargeRequestLogTypes
    );

export const updateChargeRequestLog = (chargeRequestLogTypes: ChargeRequestLogTypes) =>
    apiClient.patch<ResponseDto<any>>("/api/front/charge/updateChargeRequestLog", chargeRequestLogTypes
    );